define('boxes/helpers/signup-login',['jquery', 'all/dialog', 'all/player/session'], function ($, dialog, session) {
    'use strict';

    var signupLogin = {
        execute: function (data) {
            var info = data.PARAM_PLAYER_INFO;
            if (typeof (info) !== 'undefined') {
                window.playerinfo.init(info);
                session.login();
            } else {
                console.error('signupLogin.execute', 'PARAM_PLAYER_INFO is undefined');
            }
            $('#clock').data('offset', data.PARAM_TIME_ZONE);
        }
    };
    return signupLogin;
});
